@use "~theme/breakpoints";

.alwaysVisible {
  display: inherit;
}

.separator {
  border: 0;
  border-bottom: 1px solid var(--blue-01-at-30);
  margin: {
    left: 24px;
    right: 24px;
    bottom: 24px;
  }

  @include breakpoints.desktop {
    margin: {
      top: 0;
      left: 32px;
      right: 32px;
      bottom: 24px;
    }
  }
}

.agreement {
  margin: 0 24px;

  @include breakpoints.desktop {
    margin: 0 32px;
  }
}
